import { StockModel } from "../../Api/Models/stock.model";

export const isStockAvailable = (
    stocks: StockModel[],
    productId: number,
    variationId: number | null,
    quantity: number
): boolean => {
    const needed = Math.max(quantity ?? 0, 1);

    let productStocks = stocks.filter((stock) => stock.productId === productId);

    if (variationId !== null) {
        productStocks = productStocks.filter(
            (stock) => stock.variationId === variationId
        );
    }

    return productStocks.some((stock) => stock.quantity >= needed);
};
